import React from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import useTrans from '../../../../../hooks/useTrans'

const BozzaDigitale = ({ step, setStep, props, carrello_main }) => {
  //Da mostrare solo per ordini personalizzati
  const t = useTrans()
  return (
    <div>
      <FormField
        status={props.errors.email_bozza_digitale && 'error'}
        errorMessage={props.touched.email_bozza_digitale && props.errors.email_bozza_digitale}
        label={t('E-MAIL Per ricevere la bozza digitale')}
      >
        <FormInput
          onBlur={props.handleBlur('email_bozza_digitale')}
          value={props.values.email_bozza_digitale}
          placeholder="Inserire Email"
          onChange={(e) => props.setFieldValue('email_bozza_digitale', e.target.value)}
        />
      </FormField>
      {props.values.email_bozza_digitale && !props.errors.email_bozza_digitale && (
        <div style={{ marginTop: 10 }}>
          <Button
            label="Conferma dati"
            size="medium"
            variant="primary"
            onClick={() => {
              setStep(step + 1)
            }}
          />
        </div>
      )}
    </div>
  )
}

export default BozzaDigitale
